import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../_app";
import { EmployeeService } from "../../_service";
import { Notify, Utils } from "../../utils";
import { H3Heading, Heading } from "../appSettings/AppSettingsStyles";
import {
  CommonModal,
  CustomButton,
  CustomDateField,
  CustomNumberField,
  CustomSelectField,
  CustomTextField,
  Loader,
  NavigateBack,
} from "../../components";
import { LoaderContainer } from "../../CommonStyles";
import { DisplayFlex, RecordSeletedText } from "../payslip/PayslipStyles";
import { TableFilterHeader, TablePaginationHeader } from "./component";
import { TableHeader } from "../../components/table";
import { colors, TableRow } from "@mui/material";
import { IRASTable, IRASTableCol } from "../filing/CPFFilingStyles";
import { PulsingIcon, TableColumn } from "../users/styles";
import { Constant } from "../../config";
import CustomTooltip from "../../components/CustomTooltip";
import AnnualIncrementRow from "./AnnualIncrementRow";
import cloneDeep from "lodash.clonedeep";
import moment from "moment";
import WarningModal from "./component/WarningModal";


const InfoTextContainer = () => {
  return (
    <div style={{
      padding: "1.5rem",
      // border: "1px solid #e0e0e0",
      borderRadius: "0.75rem",

      backgroundColor: "#f8f9fa",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      width: "100%",
      border: '1px solid #333',
    }}>
      <h3 style={{
        marginBottom: "1rem",
        color: "#2c3e50",
        fontSize: "1.1rem",
        fontWeight: 600
      }}>Steps to process Annual Increment Exercise</h3>
      <ol style={{
        listStyle: "decimal",
        paddingLeft: "20px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        lineHeight: "1.8",
        color: "#4a5568",
        fontSize: "0.95rem",
        margin: 0
      }}>
        <li>Wait from TellBoss request to prepare the annual increment exercise on<br></br> the Average figure given by the Boss</li>
        <li>
          Admin prepares the result -

          Calculate annual increment for all active employees


        </li>
        <li>When ready, admin clicks here to send the result to the TellBoss App</li>
        <li>Boss reviews and makes changes, then sends revised figures to Admin</li>
        <li>Admin revises the amounts accordingly and sends them to TellBoss for final approval</li>
        <li>Admin receives approval from Boss via the TellBoss App</li>
        <li>Admin prepares annual increments into the payroll month decided by the Boss</li>
      </ol>
    </div>
  )
}

const AnnualIncrement = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const date = new Date();

  const location = useLocation();
  const locationData = location.state;
  const isEdit = locationData?.isEdit;
  const isFinalized = locationData?.isFinalized;

  const user = useAppSelector((state) => state.user);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const currentPayrunDate = useAppSelector(
    (state) => state.user.current_payrun_date
  );
  const [year, setYear] = useState(
    currentPayrunDate?.split("-")[0] || date.getFullYear()
  );
  const [effectiveDate, setEffectiveDate] = useState(moment(currentPayrunDate).format("YYYY-MM-DD"));
  useEffect(() => {
    if (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"))) {
      Notify(!['sent_for_approval', 'finalized', 'executed'].includes(status) ? `Please choose a Payroll Month that is equal to or greater than the company's current Pay Month of ${moment(currentPayrunDate).format("DD-MM-YYYY")}.` : "", 0)
    }
  }, [effectiveDate])
  // const [month, setMonth] = useState<string>(
  //   `${parseInt(currentPayrunDate?.split("-")[1] || 0) || date.getMonth() + 1}`
  // );
  const [month, setMonth] = useState<string>(
    `${parseInt(currentPayrunDate?.split("-")[1] || 0) || date.getMonth() + 1}`
  );
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openSecond, setOpenSecond] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [openUnapprove, setOpenUnapprove] = useState(false);
  const [openExecute, setOpenExecute] = useState(false);

  const [incrementPercentage, setIncrementPercentage] = useState<any>(5.0);
  const [commonIncrementPercentage, setCommonIncrementPercentage] =
    useState<any>('5.00');
  const [employeeData, setEmployeeData] = useState<any[]>([]);
  const [filteredEmployeeData, setFilteredEmployeeData] = useState<any[]>([]);

  const [inputValueIncrementPercentage, setInputValueIncrementPercentage] =
    useState<any>({});

  const [workedFrom, setWorkedFrom] = useState<any>(
    `${date.getFullYear() - 1}-01-01`
  );
  const [workedTill, setWorkedTill] = useState<any>(
    `${date.getFullYear() - 1}-12-31`
  );

  const [duplicateYearModal, setDuplicateYearModal] = useState(false)
  const [duplicateYearWarningMessage, setDuplicateYearWarningMessage] = useState("")
  const [duplicateYearWarningTitle, setDuplicateYearWarningTitle] = useState("")
  // const monthsOptions = parseInt(year) > parseInt(currentPayrunDate?.split('-')[0]) ? Utils.MONTH_OPTIONS : Utils.MONTH_OPTIONS?.slice(parseInt(currentPayrunDate?.split('-')[1]));
  // const yearOptions = Utils.getDefaultYearRange();
  const yearOptions = getYearRange(currentPayrunDate?.split('-')[0]);

  const monthsOptions = Utils.MONTH_OPTIONS;

  const [pageInfo, setPageInfo] = useState<{
    pageNumber: number;
    totalLength: number;
    pagePerData: number;
  }>({
    pageNumber: 1,
    totalLength: employeeData?.length || 10,
    pagePerData: 10,
  });

  const [totalValues, setTotalValues] = useState<any>({
    totalSalary: 0,
    totalIncrementAmount: 0,
    averageIncrementPercentage: 0
  });


  // const getEmployeeList = async (type: string) => {
  //   const defaultCompanyId = user.defaultCompnayId;

  //   if (defaultCompanyId) {
  //     setIsLoading(() => true);
  //     try {
  //       const res = await EmployeeService._getEmployeePayrollListByCompany(
  //         defaultCompanyId,
  //         Utils.getLastDayOfMonth(year, month)
  //       );
  //       if (res.status === 200) {
  //         setEmployeeData(res?.data?.data?.emp_payslip);
  //       }
  //     } catch (e: any) {
  //       console.log("err", e);
  //     }
  //     setIsLoading(() => false);
  //   }
  // };

  const getEmployeeIncrement = async () => {
    const defaultCompanyId = user.defaultCompnayId;

    if (defaultCompanyId) {
      setIsLoading(() => true);
      try {
        const res = await EmployeeService._getInitialEmployeeAnnualIncrementData(
          defaultCompanyId,
          workedFrom,
          workedTill
        );
        if (res.status === 200) {
          let data = res?.data?.data;
          console.log("increment intial data", data);
          setEmployeeData(data);
        }
      } catch (e: any) {
        console.log("err", e);
        Utils.showErrorMessage(e);
      }
      setIsLoading(() => false);
    }
  };

  const getEmployeeIncrementEditData = async () => {
    const defaultCompanyId = user.defaultCompnayId;

    if (defaultCompanyId) {
      setIsLoading(() => true);
      try {
        const res = await EmployeeService._getEmployeeAnnualIncrementEditData(locationData?.id);

        if (res.status === 200) {
          let data = res?.data?.data;
          setEmployeeData(data?.increment_records);
          // setYear(data?.increment?.year)
          // setMonth(data?.increment?.effective_month)
          // setWorkedFrom(data?.increment?.period_from)
          setEffectiveDate(data?.increment?.effective_date)
          setWorkedTill(data?.increment?.period_to)
          setCommonIncrementPercentage(data?.increment?.global_increment_percentage)
          setTotalValues({
            totalSalary: data?.increment?.total_salary,
            totalIncrementAmount: data?.increment?.total_increment,
            averageIncrementPercentage:
              data?.increment?.avg_increment_percentage,
          });
          setStatus(data?.increment?.status)
        }
      } catch (e: any) {
        console.log("err", e);
        Utils.showErrorMessage(e);
      }
      setIsLoading(() => false);
    }
  };

  useEffect(() => {
    if (isEdit || isFinalized) {
      getEmployeeIncrementEditData();
    } else {
      getEmployeeIncrement();
    }

  }, [workedFrom, workedTill]);

  // useEffect(()=> {
  //   setMonth(monthsOptions[0].value)
  // }, [year])


  // const handleIncrementPercentageChange = (id: any, text: any): any => {
  //   let index = employeeData?.findIndex((user) => user.employee === id);
  //   let data = [...employeeData];

  //   if (index >= 0) {
  //     data[index].incrementPercentage = parseFloat(text) || "";
  //     data[index].increment_percentage = parseFloat(text) || "";
  //     data[index].incrementAmount = Math.ceil(
  //       (parseFloat(text) / 100) *
  //         parseFloat(
  //           data[
  //             index
  //           ]?.salary?.replace(
  //             ",",
  //             ""
  //           )
  //         )
  //     ) || "";

  //     setEmployeeData(data);
  //   }
  //   console.log("updated", data);
  // };

  const updateTotal = (data: any) => {
    console.log("data inside updateTotal", data)
    let totalObj: any = {
      totalSalary: 0,
      totalIncrementAmount: 0,
      averageIncrementPercentage: 0
    };

    console.log('before cal1 total', totalObj)
    data.forEach((item: any) => {
      if (item.archived === true) return
      totalObj.totalSalary =
        totalObj.totalSalary +
        (parseFloat(`${item?.basic_salary}`?.replace(/,/g, "")) || 0);
      totalObj.totalIncrementAmount =
        totalObj.totalIncrementAmount + parseFloat(item?.increment_amount);
    });

    totalObj.averageIncrementPercentage = (
      ((totalObj?.totalIncrementAmount / totalObj?.totalSalary) * 100) || 0
    ).toFixed(2);

    console.log('total before update', totalObj)
    setTotalValues(totalObj);

  };
  
  const handleCommonIncrementPercentageChange = async () => {
    try {
      let data = cloneDeep(employeeData);
      const activeEmployeeIds = data?.filter(item=> item.archived !== true)?.map(item=> item.employee);
      
      if (!isEdit) {
        await EmployeeService._validateIncrementYear(
          companyId, workedTill, effectiveDate, activeEmployeeIds
        )
      }

      if (parseFloat(commonIncrementPercentage) < 0) {
        Notify("Increment percentage cannot be negative!", 0, { autoClose: false });
        return null;
      }


      // let totalObj: any = {
      //   totalSalary: 0,
      //   totalIncrementAmount: 0,
      // };

      data.forEach((item: any) => {
        // item.incrementPercentage = parseFloat(commonIncrementPercentage) || 0;
        // item.increment_percentage = parseFloat(commonIncrementPercentage) || 0;
        // item.incrementAmount =
        //   Math.ceil(
        //     (parseFloat(commonIncrementPercentage) / 100) *
        //       parseFloat(`${item.basic_salary}`?.replace(/,/g, ""))
        //   ) || 0;
        // item.increment_amount =
        //   Math.ceil(
        //     (parseFloat(commonIncrementPercentage) / 100) *
        //       parseFloat(`${item.basic_salary}`?.replace(/,/g, ""))
        //   ) || 0;

        // total calc
        // totalObj.totalSalary =
        //   totalObj.totalSalary +
        //   (parseFloat(item?.basic_salary?.replace(/,/g, "")) || 0);
        // totalObj.totalIncrementAmount =
        //   totalObj.totalIncrementAmount + Number(item?.incrementAmount);


        let joiningDateObj = moment(item?.date_joined);
        let daysWorked = moment(`${workedTill}`).diff(joiningDateObj, "days") + 1; // added one to inclue the joining date

        if (daysWorked < 365) {
          item.incrementPercentage =
            parseFloat(((daysWorked / 365) * (parseFloat(commonIncrementPercentage) || 0)).toFixed(2));
          item.increment_percentage = item.incrementPercentage;

          item.incrementAmount =
            Math.ceil(
              (parseFloat(item.incrementPercentage) / 100) *
              parseFloat(`${item.basic_salary}`?.replace(/,/g, ""))
            ) || 0;
          item.increment_amount = item.incrementAmount;
        } else {
          item.incrementPercentage = parseFloat(commonIncrementPercentage) || 0;
          item.increment_percentage = parseFloat(commonIncrementPercentage) || 0;
          item.incrementAmount =
            Math.ceil(
              (parseFloat(commonIncrementPercentage) / 100) *
              parseFloat(`${item.basic_salary}`?.replace(/,/g, ""))
            ) || 0;
          item.increment_amount =
            Math.ceil(
              (parseFloat(commonIncrementPercentage) / 100) *
              parseFloat(`${item.basic_salary}`?.replace(/,/g, ""))
            ) || 0;
        }

      });

      setEmployeeData(data);
      updateTotal(data);

      console.log("updated", data,);
    } catch (e) {
      setDuplicateYearWarningMessage(e.response.data.message)
      setDuplicateYearWarningTitle(e.response.data.error)
      setDuplicateYearModal(true)
      setWorkedTill("")
      setEffectiveDate("")
    }
  };

  // const handleIncrementAmountChange = (id: any, text: any): any => {
  //   let index = employeeData?.findIndex((user) => user.employee === id);
  //   let data = [...employeeData];

  //   if (index >= 0) {
  //     // data[index].incrementPercentage = parseFloat(text) || "";
  //     data[index].incrementAmount = parseFloat(text);
  //     data[index].increment_amount = parseFloat(text);

  //     data[index].incrementPercentage = (( parseFloat(text) / parseFloat(data[index].salary?.replace(/,/g, "")) ) || 0) * 100;
  //     data[index].incrementPercentage = data[index].incrementPercentage === Infinity ? 0 : data[index].incrementPercentage?.toFixed(2);

  //     data[index].increment_percentage = data[index].incrementPercentage;

  //     setEmployeeData(data);
  //   }
  //   console.log("updated", data);
  // };

  const handleApprove = async (id: any, action: String) => {
    if (action == 'approve' && moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"))) {
      setOpenWarn(true)
      return;
    }
    try {
      const { status, data } = await EmployeeService._sendForTellbossApprovalIncrement(id, action);
      if (status === 200) {
        Notify(data.message, 1)
        navigate(-1)
      }

    } catch (error) {
      Notify("Something went wrong", 0)
    }

  }
  const handleExecute = async (id: any) => {

    try {
      const { status, data } = await EmployeeService._sendForExcuteIncrement(id);
      if (status === 200) {
        Notify(data.message, 1)
        setOpenConfirm(false)
        navigate(-1)
      }

    } catch (error) {
      Notify("Something went wrong", 0)
    }

  }

  const handlePageValueChange = (
    type: "next" | "previous" | "first" | "last"
  ) => {
    if (type === "next") {
      const isLast =
        pageInfo.pageNumber * pageInfo.pagePerData < employeeData.length;
      if (isLast) {
        setPageInfo((prev) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }));
      }
    }
    if (type === "previous") {
      if (pageInfo.pageNumber > 1) {
        setPageInfo((prev) => ({
          ...prev,
          pageNumber: prev.pageNumber - 1,
        }));
      }
    }
    if (type === "first") {
      setPageInfo((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
    }
    if (type === "last") {
      setPageInfo((prev) => ({
        ...prev,
        pageNumber: Math.ceil(pageInfo.totalLength / pageInfo.pagePerData),
      }));
    }
  };

  const handleSave = async (isDraft: boolean, goBack: boolean = false) => {
    console.log('theData inside handleSave', employeeData, totalValues)
    setOpen(false);

    let payload: any = {
      increment: {},
      increment_records: [],
    }

    let data = cloneDeep(employeeData);

    payload.increment_records = data?.map((emp: any) => {
      let newEmp: any = {};
      Object.keys(emp).forEach((key: any) => {
        if (key === "incrementAmount") {
          newEmp.increment_amount = emp[key];
        } else if (key === "incrementPercentage") {
          newEmp.increment_percentage = emp[key];
        } else if (key === "basic_salary") {
          newEmp[key] = `${emp[key]}`?.replace(/,/g, "");
        }
        else {
          newEmp[key] = emp[key];
        }
      });
      return newEmp;
    });

    if (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"))) {
      Notify("Please choose the latest unfinalised Pay Month or future Pay Month.", 0)
      return;
    }


    payload.increment = {
      "company": companyId,
      // "year": year,
      // "effective_month": month,
      // "period_from": workedFrom,
      "effective_date": effectiveDate,
      "period_to": workedTill,
      "global_increment_percentage": commonIncrementPercentage,
      "status": isDraft ? "preview" : "sent_for_approval",
      "total_salary": totalValues?.totalSalary,
      "total_increment": totalValues?.totalIncrementAmount,
      "avg_increment_percentage": totalValues?.averageIncrementPercentage
    }

    if (isEdit) {
      payload.increment.id = locationData?.id
    }

    console.log("thePayload", payload)

    try {
      const { status } = isEdit ? await EmployeeService._updateAnnualIncrement(payload) : await EmployeeService._saveAnnualIncrement(payload);

      if (status >= 200 && status < 300) {
        Notify(isEdit ? "Annual Increment Updated" : "Annual Increment Saved", 1);

        if (goBack) {
          navigate(-1);
        }
      }
    } catch (error: any) {
      if (error?.response?.data?.paylsip) {
        Notify(error?.response?.data?.paylsip, 0);
        Utils.showErrorMessage(error);
      } else {
        Utils.showErrorMessage(error);
        // Notify(Constant.common.something_went_wrong, 0);
      }
    }
  };



  // Only when updating from row and isEdit=true
  const handleSaveRow = async (empData: any) => {
    console.log('handleSaveRow called')
    let totalObj: any = {
      totalSalary: 0,
      totalIncrementAmount: 0,
      averageIncrementPercentage: 0
    };

    empData.forEach((item: any) => {
      totalObj.totalSalary =
        totalObj.totalSalary +
        (parseFloat(`${item?.basic_salary}`?.replace(/,/g, "")) || 0);
      totalObj.totalIncrementAmount =
        totalObj.totalIncrementAmount + parseFloat(item?.increment_amount);
    });

    totalObj.averageIncrementPercentage = (
      ((totalObj?.totalIncrementAmount / totalObj?.totalSalary) * 100) || 0
    ).toFixed(2);

    // -----------

    let payload: any = {
      increment: {},
      increment_records: [],
    }

    payload.increment_records = empData?.map((emp: any) => {
      let newEmp: any = {};
      Object.keys(emp).forEach((key: any) => {
        if (key === "incrementAmount") {
          newEmp.increment_amount = emp[key];
        } else if (key === "incrementPercentage") {
          newEmp.increment_percentage = emp[key];
        } else if (key === "basic_salary") {
          newEmp[key] = `${emp[key]}`?.replace(/,/g, "");
        }
        else {
          newEmp[key] = emp[key];
        }
      });
      return newEmp;
    });

    payload.increment = {
      "company": companyId,
      // "year": year,
      // "effective_month": month,
      // "period_from": workedFrom,
      "effective_date": effectiveDate,
      "period_to": workedTill,
      "global_increment_percentage": commonIncrementPercentage,
      "status": "preview",
      "total_salary": totalObj?.totalSalary,
      "total_increment": totalObj?.totalIncrementAmount,
      "avg_increment_percentage": totalObj?.averageIncrementPercentage
    }

    if (isEdit) {
      payload.increment.id = locationData?.id
    }

    console.log("thePayload-RowUpdate", payload)

    try {
      const { status } = await EmployeeService._updateAnnualIncrement(payload);
      if (status >= 200 && status < 300) {
        Notify("Annual Increment Updated", 1);
      }
    } catch (error: any) {
      if (error?.response?.data?.paylsip) {

        Utils.showErrorMessage(error);
        // Notify(error?.response?.data?.paylsip, 0);
      } else {
        Utils.showErrorMessage(error);
        // Notify(Constant.common.something_went_wrong, 0);
      }
    }

  }

  const handleRowUpdate = (empId: any, amount: any) => {
    console.log('inside onUpdate', empId, amount)
    let index = employeeData?.findIndex((user) => user.employee === empId);
    let data = cloneDeep(employeeData)

    if (index >= 0) {
      data[index].incrementAmount = parseFloat(amount);
      data[index].increment_amount = parseFloat(amount);

      data[index].incrementPercentage = ((parseFloat(amount) / parseFloat(`${data[index]?.basic_salary}`?.replace(/,/g, ""))) || 0) * 100;
      data[index].incrementPercentage = data[index]?.incrementPercentage === Infinity ? 0 : parseFloat(data[index]?.incrementPercentage).toFixed(2);

      data[index].increment_percentage = data[index].incrementPercentage;

      setEmployeeData(data);
      updateTotal(data);
    }

    if (isEdit) {
      handleSaveRow(data);
    }

  }
  const handleDelete = (empId: any) => {
    console.log('inside handleDelete', empId)
    let index = employeeData?.findIndex((user) => user.employee === empId);
    let data = cloneDeep(employeeData)

    if (index >= 0) {
      data[index].archived = true

      setEmployeeData(data);
      updateTotal(data);
    }

    console.log(data)

  }
  // page change
  useEffect(() => {
    const startIndex =
      pageInfo.pageNumber * pageInfo.pagePerData - pageInfo.pagePerData;
    const endIndex =
      pageInfo.pageNumber * pageInfo.pagePerData > employeeData.length
        ? employeeData.length
        : pageInfo.pageNumber * pageInfo.pagePerData;

    setPageInfo((prev) => ({
      ...prev,
      totalLength: employeeData?.length,
    }));


    setFilteredEmployeeData(() => employeeData.slice(startIndex, endIndex));
  }, [pageInfo.pageNumber, employeeData]);


  {
    // console.log("theData", employeeData, locationData, isEdit, totalValues);
    console.log("theData", employeeData, filteredEmployeeData);
    console.log("currentPayrunDate", { currentPayrunDate, month, year, monthsOptions })
  }

  return (
    <div style={{
      // pointerEvents: isFinalized ? 'none' : 'auto'
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: ".7rem"
      }}>
        <NavigateBack />
        <Heading>{"Annual Increments"}</Heading>
        <H3Heading style={{
        }}>- {user.defaultCompany}</H3Heading>
        <CustomTooltip title={<InfoTextContainer />} placement={'right'}>
          <PulsingIcon>
            <img src="/info-outline.svg" style={{ width: '25px' }} />
          </PulsingIcon>
        </CustomTooltip>
      </div>

      <div style={{
        display: 'flex',
        gap: "5px"
      }}>

        <div
          style={{
            // padding: "1.5rem",
            paddingLeft: "1rem",
            paddingTop: ".5rem",
            margin: "1rem 1.75rem 1rem auto",
            borderRadius: "0.75rem",
            backgroundColor: "#f8f9fa",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            border: "1px solid #333",
            width: "50%",

          }}
        >
          <div style={{ width: "50%" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1.5rem",
                justifyItems: "flex-start",
                width: "fit-content",
              }}
            >
              <span
                style={{
                  // margin: "1rem 0",
                  marginTop: "1rem",
                  color: "rgb(71, 101, 117)",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {`2. Increment For Employees Who Worked till `}
              </span>
              <CustomDateField
                date={workedTill}
                setDate={setWorkedTill}
                startYear={new Date().getFullYear() - 3}
                endYear={new Date().getFullYear() + 6}
                openAsModal={false}
                disabled={isEdit === true || isFinalized === true}
                require
              />
            </div>

            {/* <div
              style={{
                display: "flex",
                gap: 20,
                width: "100%",
                alignItems: "center",
                whiteSpace: "nowrap",
                marginTop: ".8rem"

              }}
            >
              <p style={{ color: "#333" }}>2. Annual Increment for the year:</p>
              <div>
                <CustomSelectField
                  value={year}
                  onChangeOption={(value) => setYear(value)}
                  option={yearOptions.map((year) => ({
                    key: year,
                    value: year,
                  }))}
                  disabled={isLoading}
                  isDate={true}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: 20,
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: ".8rem"

              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 20, whiteSpace: "nowrap" }}>
                <p style={{ color: "#333" }}>
                  3. Salary Increment effective month from:
                </p>
                <div>
                  <CustomSelectField
                    value={month}
                    onChangeOption={(value) => setMonth(value)}
                    option={monthsOptions.map((month) => ({
                      key: month.key,
                      value: month.value,
                    }))}
                    disabled={isLoading}
                    isDate={true}
                  />
                </div>
              </div>
            </div> */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                width: "fit-content",
              }}
            >
              <span
                style={{
                  margin: ".5rem 0",
                  marginTop: "1.2rem",
                  color: "rgb(71, 101, 117)",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {"3. Add to Payroll Month"}
              </span>
              <CustomDateField
                date={effectiveDate}
                setDate={setEffectiveDate}
                disabled={status === "finalized" || status === "sent_for_approval" || status === "executed"}
                require
              />


            </div>

            {!['sent_for_approval', 'finalized', 'executed'].includes(status) && <span style={{
              color: '#D32F2F',
              fontSize: '14px',
              marginTop: '4px',
              whiteSpace: "nowrap"
            }}>
              {moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) && (
                <>
                  <span style={{ fontSize: '15px' }}></span>
                  <span>⚠️ Please choose the latest unfinalised Pay Month or future Pay Month after {moment(currentPayrunDate).format("DD-MM-YYYY")}.</span>
                </>
              )}
            </span>}

            <div
              style={{
                display: "flex",
                gap: 20,
                width: "70%",
                alignItems: "center",
                whiteSpace: "nowrap",
                marginTop: ".8rem"

              }}
            >
              <p style={{ color: "#333" }}>4. Enter Increment Percentage ( % ):</p>
              <div>
                <CustomNumberField
                  value={commonIncrementPercentage}
                  removeNumIcon={false}
                  onChangeText={(text) => {
                    setCommonIncrementPercentage(text);
                  }}
                  onBlur={() => {
                    if (parseFloat(commonIncrementPercentage) < 0) {
                      Notify("Increment percentage cannot be negative!", 0, {
                        autoClose: false,
                      });
                    } else {
                      setCommonIncrementPercentage(
                        `${(parseFloat(commonIncrementPercentage) || 0).toFixed(2)}`
                      );
                    }
                  }}
                  width="100px"
                  disabled={isFinalized}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: 20,
                marginTop: "1rem",
                width: "100%",
                alignItems: "center",
                color: "rgb(51, 51, 51)",
              }}
            >
              <p style={{ textTransform: "capitalize", whiteSpace: "nowrap" }}>
                5. Calculate Annual Increment for All Active employees:{" "}
              </p>
              {/* <CustomTooltip title={"Click to Start Calculating"} placement={"right"}>
                <img
                  style={{ width: "2rem", cursor: "pointer" }}
                  src="/refresh_blue.svg"
                />
              </CustomTooltip> */}
              <CustomButton
                title="Calculate"
                onClick={handleCommonIncrementPercentageChange}
                styles={{
                  marginRight: "2rem",
                  width: "fit-content",
                  marginLeft: "0px",
                  whiteSpace: "nowrap",

                }}
                disable={status === "finalized" || status === "sent_for_approval" || status === "executed"}
              />
            </div>


          </div>
        </div>

        <div style={{
          padding: "1.5rem",
          // border: "1px solid #e0e0e0",
          borderRadius: "0.75rem",
          margin: '1rem 0',
          marginLeft: 'auto',
          marginRight: "1.75rem",
          backgroundColor: "#f8f9fa",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          width: "45%",
          border: '1px solid #333',
        }}>
          <h3 style={{
            marginBottom: "1rem",
            color: "#2c3e50",
            fontSize: "1.1rem",
            fontWeight: 600
          }}>Steps to process Annual Increment Exercise</h3>
          <ol style={{
            listStyle: "decimal",
            paddingLeft: "20px",
            fontFamily: "system-ui, -apple-system, sans-serif",
            lineHeight: "1.8",
            color: "#4a5568",
            fontSize: "1rem",
            margin: 0
          }}>
            <li>Wait from TellBoss request to prepare the annual increment exercise on ( normal about 4% - 8% ) the Average figure given by the Boss</li>
            <li>
              Admin prepares the result -
              {/* <p style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                margin: "4px 0",
                padding: "4px 8px",
                backgroundColor: "#edf2f7",
                borderRadius: "4px",
                fontSize: "1rem",
                color: "#718096",
                fontWeight: 500,
                fontStyle: "italic",
              }}> */}
              <>Calculate annual increment for all active employees</>
              {/* <CustomTooltip title={"Click to Start Calculating"} placement={"right"}>
                  <img
                    onClick={handleCommonIncrementPercentageChange}
                    style={{ width: "1.5rem", cursor: "pointer" }}
                    src="/refresh_blue.svg"
                  />
                </CustomTooltip>
              </p> */}
            </li>
            <li>When ready, admin clicks here to send the result to the TellBoss App</li>
            <li>Boss reviews and makes changes, then sends revised figures to Admin</li>
            <li>Admin changes the amounts accordingly and sends them to TellBoss for final approval</li>
            <li>Admin receives approval from Boss via the TellBoss App</li>
            <li>Admin prepares annual increments into the payroll month decided by the Boss</li>
          </ol>
        </div>

      </div>

      {/* <div
        style={{
          display: "flex",
          gap: 20,
          width: "70%",
          alignItems: "center",
        }}
      ></div> */}

      {/* For total table */}
      <table
        style={{ width: "100%", marginTop: "1rem" }}
        className="company-table"
      >
        <thead className="company-table-head" style={{ textAlign: "right" }}>
          <tr>
            <th style={{ width: "28%", textAlign: "left" }}>Total Employees</th>
            {/* <th  style={{ width: "25%", textAlign: "center",  }}>Total:</th> */}
            <th style={{ width: "36%", textAlign: "right" }}>Total Salary</th>
            <th style={{ width: "12%", textAlign: "right" }}>
              Total Increments
            </th>
            <th style={{ width: "12%", textAlign: "right" }}>
              Average Increment %
            </th>
            <th style={{ width: "12%", textAlign: "left" }}>
              {""}
            </th>
          </tr>
        </thead>
        <tr>
          {/* <td style={{textAlign: 'center'}}>{"   "}</td> */}
          <td style={{ width: "28%", textAlign: "left" }}>

            {employeeData?.length}

          </td>
          <td style={{ width: "36%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalSalary || 0)}
          </td>
          <td style={{ width: "12%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalIncrementAmount || 0)}
          </td>
          <td style={{ width: "12%", textAlign: "right" }}>
            {/* {(
              (totalValues?.totalIncrementAmount / totalValues?.totalSalary) *
                100 || 0
            ).toFixed(2)} */}
            {totalValues?.averageIncrementPercentage || 0.00.toFixed(2)}
            %
          </td>
          <td style={{ width: "12%", textAlign: "right" }}>{""}</td>
        </tr>
      </table>

      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <>
          <section id="report-table" style={{ marginTop: 20 }}>
            <>
              <div style={{ width: "100%" }}>
                <TableFilterHeader
                  name="Employees"
                  pageInfo={pageInfo}
                  setPageInfo={setPageInfo}
                  handlePageValueChange={(val) => handlePageValueChange(val)}
                />

                <div className="table">
                  <table className="company-table">
                    <thead className="company-table-head">
                      <tr>
                        <th style={{ width: "20%", textAlign: "left" }}>Employee Name</th>
                        <th style={{ width: "8%", textAlign: "left" }}>Hourly</th>
                        <th style={{ width: "12%", textAlign: "left" }}>Date Joined</th>
                        <th style={{ width: "12%", textAlign: "left" }}>Resigned Date</th>
                        <th style={{ width: "8%", textAlign: "left" }}>Employee ID</th>
                        <th style={{ width: "14%", textAlign: "right" }}>Basic Salary</th>
                        <th style={{ width: "14%", textAlign: "right" }}>Increment Amount</th>
                        <th style={{ width: "12%", textAlign: "right" }}> Increment Percentage (%) </th>

                        {!isFinalized && <th style={{ textAlign: "center", width: "15%" }}>
                          Action
                        </th>}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredEmployeeData?.length > 0 ? (
                        filteredEmployeeData?.map((item, index) => {
                          if (item.archived === true) return
                          return (
                            <AnnualIncrementRow
                              key={item?.employee}
                              data={item}
                              onUpdate={handleRowUpdate}
                              isEdit={isEdit}
                              isFinalized={isFinalized}
                              onDelete={handleDelete}
                            />
                          )
                        }
                        )
                      ) : (
                        <p style={{ textAlign: "center", margin: "2rem" }}>
                          No records found
                        </p>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          </section>
        </>
      )}
      <div style={{
        textAlign: "right",
        display: "flex",
        justifyContent: "space-between"
      }}>
        <div></div>
        <div style={{
          display: "flex",
          flexDirection: "row"
        }}>
          {(!isFinalized && isEdit) && (
            <CustomButton
              title={"6. Proceed to Save Draft"}
              onClick={() => setOpenSecond(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",
                cursor: (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate) ? "not-allowed" : "pointer"
              }}
              disable={moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate}

            />
          )}
          {!isFinalized && (
            <CustomButton
              title={isEdit ? "7. Ready to send for approval?" : "6. Ready to send to listing page as draft?"}
              onClick={() => setOpen(true)}
              styles={{
                marginRight: "2rem",
                backgroundColor: `${isEdit ? "#2E7D32" : ""}`,
                border: `${isEdit ? "#2E7D32" : ""}`,
                color: `${isEdit ? "#fff" : ""}`,
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "1rem",
                whiteSpace: "nowrap",
                cursor: (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate) ? "not-allowed" : "pointer"
              }}
              disable={moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate}
            />
          )}


          {(isFinalized && status === "sent_for_approval") && (
            <CustomButton
              title="8. Boss Approval Received?"
              onClick={() => {
                if (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"))) {
                  setOpenWarn(true);
                } else {
                  setOpenConfirm(true);
                }
              }} styles={{
                marginRight: "2rem",
                backgroundColor: '#2E7D32',
                border: "#2E7D32",
                color: '#FFFFFF',
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )}

          {(isFinalized && status === "sent_for_approval") && (
            <CustomButton
              title="9. Unapprove Annual increment?"
              onClick={() => setOpenUnapprove(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                backgroundColor: "#F57C00",
                border: "#F57C00",
                color: '#FFFFFF',
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )}


          {(isFinalized && status === "finalized") && (
            <CustomButton
              title="7. Execute Annual increment?"
              onClick={() => setOpenExecute(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                backgroundColor: '#216ba5',
                color: '#FFFFFF',
                border: "#216ba5",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )}
        </div>
      </div>

      <CommonModal
        handleClose={() => setOpen(false)}
        open={open}
        updateData={() => isEdit ? handleSave(false, true) : handleSave(true, true)}
        body={`${isEdit ? "Proceed with confirmation before sending Annual Increments to Tellboss Payroll." : "When you click “Save Draft”, the system will save Annual Increments as draft for later confirmation."}`}
        heading={isEdit ? "Ready to send for approval?" : "Ready to save Annual Increments to draft?"}
        conformButtonText={isEdit ? "Proceed for approval" : "Proceed to Save Draft"}
        cancelButtonText={isEdit ? "No - Stop" : "No - Stop"}
        onCancel={() => isEdit ? setOpen(false) : setOpen(false)}

      />

      <CommonModal
        handleClose={() => setOpenSecond(false)}
        open={openSecond}
        updateData={() => handleSave(true, true)}
        body={"When you click “Save Draft”, the system will save Annual increment as draft for later confirmation."}
        heading={"Ready to save Annual increment calculations to draft?"}
        conformButtonText={"Proceed to Save Draft"}
        cancelButtonText={"Cancel Stop"}
        onCancel={() => setOpenSecond(false)}

      />
      <CommonModal
        handleClose={() => setOpenConfirm(false)}
        open={openConfirm}
        updateData={() => handleApprove(locationData?.id, "approve")}
        body={`Proceed to confirm Draft Annual Increment as Final and send to payslips in payroll?`}
        heading={"Ready to confirm Draft Annual Increment?"}
        conformButtonText={"Proceed to confirm"}
        cancelButtonText={"No - Stop"}
        onCancel={() => setOpenConfirm(false)}

      />
      <CommonModal
        handleClose={() => setOpenUnapprove(false)}
        open={openUnapprove}
        updateData={() => handleApprove(locationData?.id, "unapprove")}
        body={`Proceed to confirm Draft Annual increment Unapprove the increment?`}
        heading={"Ready to confirm Draft Annual increment UnApprove?"}
        conformButtonText={"Continue"}
        cancelButtonText={"Cancel"}
        onCancel={() => setOpenConfirm(false)}

      />
      <CommonModal
        handleClose={() => setOpenExecute(false)}
        open={openExecute}
        updateData={() => handleExecute(locationData?.id)}
        body={`The execution date is ${moment(effectiveDate).format("DD-MM-YYYY")}. Do you really want to proceed with today's date?`}
        heading={"Ready to excute Annual increment?"}
        conformButtonText={"Continue"}
        cancelButtonText={"Cancel"}
        onCancel={() => setOpenConfirm(false)}

      />

      <WarningModal
        isOpen={duplicateYearModal}
        onClose={() => setDuplicateYearModal(false)}
        title={duplicateYearWarningTitle}
        message={duplicateYearWarningMessage}
        actionText="Ok"
        onAction={() => setDuplicateYearModal(false)}
      />

      <WarningModal
        isOpen={openWarn}
        onClose={() => setOpenWarn(false)}
        title="Action Required"
        message="To proceed with a past Payrun Date, please unapprove the bonus first. Are you sure you want to continue with this action?"
        actionText="Yes, Proceed"
        onAction={() => handleApprove(locationData?.id, "")}
      />

    </div>
  );
};

export default AnnualIncrement;

const getYearRange = (year: string) => {
  const startYear = parseInt(year);
  const yearsRange = [startYear];

  for (let i = 1; i < 10; i++) {
    yearsRange.push(startYear + i);
  }
  console.log("inside yearRange", { startYear, yearsRange });
  return yearsRange;
};
